import { render, staticRenderFns } from "./SalesDeliveryDataEdit.vue?vue&type=template&id=222d40d6&scoped=true&"
import script from "./SalesDeliveryDataEdit.vue?vue&type=script&lang=js&"
export * from "./SalesDeliveryDataEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222d40d6",
  null
  
)

export default component.exports